import React, { ReactElement } from 'react';
import HelpIcon from '@mui/icons-material/Help';
import InputAdornment from '@mui/material/InputAdornment';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import useDictionary from '@ui/hooks/useDictionary';
import { IProps } from './IProps';

const Component: React.FC<IProps> = ({ data }: IProps) => {
    const getWord = useDictionary();

    let message: ReactElement | ReactElement[] | undefined;
    if (typeof data === 'string') {
        message = (
            <Typography className="input-adornment__text">
                {getWord(data)}
            </Typography>
        );
    } else if (typeof data === 'object' && Array.isArray(data)) {
        message = data.map((txt) => (
            <Typography className="input-adornment__text">
                {getWord(txt)}
            </Typography>
        ));
    }

    return (
        <InputAdornment position="start">
            <Tooltip
                classes={{
                    popper: 'input-adornment__tooltip-popper',
                    tooltip: 'input-adornment__tooltip',
                }}
                title={message}
                placement="top"
            >
                <HelpIcon className="input-adornment__ico" />
            </Tooltip>
        </InputAdornment>
    );
};

const InputAdornmentComponent = React.memo(Component);

export default InputAdornmentComponent;
